module.exports = __webpack_public_path__ + "static/course-listeningPractice-ce66162263163001303f66294dfb5350.png";